import { Injectable } from '@angular/core';
import { DateHelpers, SessionService } from '@edl-development/edl-common';
import { CustomFormType } from 'src/app/model/enum/observations/custom-forms/custom-form-type.enum';
import { CustomFormQuestionDisplayDTO } from 'src/app/model/observation/custom-forms/custom-form-question-dto.model';
import { CustomFormUserFormDisplayDTO } from 'src/app/model/observation/custom-forms/custom-form-user-form-display-dto.model';
import { CfUfPermissionsDto } from 'src/app/model/observation/custom-forms/permissions/cf-uf-permissions-dto.model';

@Injectable({
    providedIn: 'root'
})
export class CustomFormsHelpersService {

    constructor(private sessionService: SessionService) { }

    getOptionId = (question: CustomFormQuestionDisplayDTO<any>, optionIndex: number) => {
        return `${question.questionID}_${optionIndex}`
    }

    getOptionIndexFromId = (optionId?: string | null) => {
        return optionId ? parseInt(optionId.split('_')[1]) : -1;
    }

    getCustomFormTypeLabel = (formType?: CustomFormType) => {
        if (formType === undefined || formType === null) return '';

        return formType === CustomFormType.INDIVIDUAL ? 'Individual' : 'Supervisor';
    }  

    // In order for Deserialization to work in .Net Core 8 the $type property must be the first property in the object
    // User this function to create Custom Form Questions to garentee the $type property is the first property
    createCustomFormQuestion<T extends any>(question: CustomFormQuestionDisplayDTO<T>): CustomFormQuestionDisplayDTO<T> {
        const { $type, ...rest } = question;
        
        return {
            $type: $type,
            ...rest
        }
    }

    generatePreviewPermissions(): CfUfPermissionsDto {
        return {
            basePermissions: {
                canView: true,
                canSave: true,
                canSubmit: false,
                canComment: false
            },
            signaturePermissions: {
                typesCanSign: []
            }
        }
    }

    generatePreviewUserForm({
        formTitle,
        formType,
        permissions
    }: {
        formTitle: string,
        formType: CustomFormType, 
        permissions: CfUfPermissionsDto
    }): CustomFormUserFormDisplayDTO {
        const schoolYears = this.sessionService.GetSessionValue('school_years') as string[];
        const schoolYear = schoolYears[0] ?? '';

        return {
            formId: 'formId',
            userFormId: 'userFormId',
            targetUserId: 'targetUserId',
            targetEmail: 'targetEmail',
            supervisorId: 'supervisorId',
            supervisorEmail: 'supervisorEmail',
            targetUserName: 'Supervisee',
            supervisorName: 'Supervisor',
            completedDate: DateHelpers.getMinDate(),
            createdDate: new Date(),
            modifiedDate: DateHelpers.getMinDate(),
            schoolYear,
            completed: false,
            formTitle,
            formType,
            delete_Date: DateHelpers.getMinDate(),
            delete_User: '',
            delete_Flag: false,
            permissions,
            formAnswers: {}
        }
    }
}
